module.exports = __webpack_public_path__ + "assets/img/1.8c7b8971.png";